<script>
  import Matrix from "../../shared/Matrix.svelte";
  import { _ } from "svelte-i18n";

  const matrix1 = [
    ["a", "b", "c", "d"],
    ["e", "f", "g", "h"],
    ["i", "j", "k", "l"],
    ["m", "n", "o", "p"],
  ]
</script>

<div class="title">
  <h2>{$_("lesson-0nRrT.h2-0")}</h2>
</div>
<hr />
<div class="text">
  <p>
    {$_("lesson-0nRrT.p-0")}
  </p>
  <ol>
    <li>{$_("lesson-0nRrT.li-0")}</li>
    <li>{$_("lesson-0nRrT.li-1")}</li>
  </ol>
  <p>
    {$_("lesson-0nRrT.p-1")}
  </p>
  <Matrix data={matrix1} size=200 showLabels={false}/>
  <p>
    {`$$f\\left(a,...,p\\right)=\\left(a+b+c+d-1\\right)^2+\\left(e+f+g+h-1\\right)^2+\\left(i+j+k+l-1\\right)^2+\\left(m+n+o+p-1\\right)^2$$`}
    {`$$+\\left(a+e+i+m-1\\right)^2+\\left(b+f+j+n-1\\right)^2+\\left(c+g+k+o-1\\right)^2+\\left(d+h+l+p-1\\right)^2$$`}
    {`$$=-2a+2ab+2ac+2ad+2ae+2ai+2am-2b+2bc+2bd+2bf+2bj+2bn-2c+2cd+2cg+2ck+2co$$`}
    {`$$-2d+2dh+2dl+2dp-2e+2ef+2eg+2eh+2ei+2em-2f+2fg+2fh+2fj+2fn-2g+2gh+2gk+2go$$`}
    {`$$-2h+2hl+2hp-2i+2ij+2ik+2il+2im-2j+2jk+2jl+2jn-2k+2kl+2ko-2l+2lp-2m+2mn+2mo+2mp$$`}
    {`$$-2n+2no+2np-2o+2op-2p+8$$`}
  </p>
  <p>
    {@html $_("lesson-0nRrT.p-2")}
  </p>
  <div align="center"><img width="220" src="/img/MatrixArrows.png" alt="A Tour Matrix where from each node, arrows point to all possible destinations in the next timestamp"></div>
  <p>
    {@html $_("lesson-0nRrT.p-3-0")}
    {`$$6.6af+6.6bg+6.6ch+6.6de+5.4aj+5.4bk+5.4cl+5.4di+4.0an+4.0bo+4.0cp+4.0dm+6.6eb+6.6fc$$`}
    {`$$+6.6gd+6.6ha+1.6ej+1.6fk+1.6gl+1.6hi+3.6en+3.6fo+3.6gp+3.6hm+5.4ib+5.4jc+5.4kd+5.4la$$`}
    {`$$+1.6if+1.6jg+1.6kh+1.6le+3.2in+3.2jo+3.2kp+3.2lm+4.0mb+4.0nc+4.0od+4.0pa+3.6mf+3.6ng$$`}
    {`$$+3.6oh+3.6pe+3.2mj+3.2nk+3.2ol+3.2pi$$`}
    {@html $_("lesson-0nRrT.p-3-1")}
  </p>
  <div align="center"><strong>{$_("lesson-0nRrT.strong-0")}</strong></div>
</div>

<style>
  .title h2 {
    background: -webkit-linear-gradient(90deg, #1a91bc, #2eb6e8);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  hr {
    border: 1px solid white;
    border-top: 1px solid #ddd;
    margin: 20px auto;
  }
</style>
